export const FORM_BUTTON_TYPE_BUTTON = 'button'
export const FORM_BUTTON_TYPE_SUBMIT = 'submit'
